import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FadeUp, Overline } from "./Motion";

export const FAQ = ({ items, title = "Dúvidas frequentes" }) => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-[1360px] px-6 lg:px-10 py-24 md:py-32">
    <div className="grid gap-12 lg:grid-cols-12">
      <FadeUp className="lg:col-span-4">
        <Overline>Perguntas</Overline>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl text-white leading-[1.05]">{title}</h2>
      </FadeUp>
      <FadeUp delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-[#D4AF37]/20">
          {items.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-b border-[#D4AF37]/20">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-7 text-left font-display text-xl md:text-2xl text-white hover:no-underline hover:text-[#E6C687] [&>svg]:text-[#D4AF37]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-7 text-base text-[#C0C9DC] leading-relaxed max-w-2xl">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeUp>
    </div>
  </section>
);
